import { NewMessageResponse } from "../entities/onNewMessageSocket";
import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class OnNewMessage {
	constructor(private repository: ChatSocketRepository) {}

	execute(callback: (data: NewMessageResponse) => void): void {
		return this.repository.onNewMessage(callback);
	}
}
